module.exports = __webpack_public_path__ + "img/aa491d0.jpg";